import { z } from '@hono/zod-openapi';

export const registerForEventRequestSchema = z.object({
  firstName: z
    .string()
    .min(1, { message: 'First name is required' })
    .openapi({ description: 'First name of the user' }),
  lastName: z
    .string()
    .min(1, { message: 'Last name is required' })
    .openapi({ description: 'Last name of the user' }),
  email: z
    .string()
    .email()
    .openapi({ description: 'Email address of the user' }),
  phone: z
    .string()
    .min(1, { message: 'Phone number is required' })
    .openapi({ description: 'Phone number of the user' }),
  gender: z
    .string({ required_error: 'Gender is required' })
    .min(1, { message: 'Gender is required' })
    .openapi({ description: 'Gender of the user' }),
  isInternalVolunteer: z
    .boolean()
    // TODO: make this required post v1
    // .boolean({
    //   required_error: 'You must select an option.',
    //   invalid_type_error: 'You must select an option.'
    // })
    .optional()
    .nullable()
    .openapi({
      description:
        'Whether the user is an internal volunteer or public volunteer. Tracking purposes only for v1.'
    }),
  acceptedPhoneTermsAt: z
    .string()
    .min(1, { message: 'Phone terms acceptance is required' })
    .datetime()
    .openapi({ description: 'Timestamp when phone terms were accepted' }),
  acceptedCancellationPolicyAt: z
    .string()
    .min(1, { message: 'Cancellation policy acceptance is required' })
    .datetime()
    .openapi({
      description: 'Timestamp when cancellation policy was accepted'
    }),
  acceptedTermsAndConditionsAt: z
    .string()
    .min(1, { message: 'Terms and conditions acceptance is required' })
    .datetime()
    .openapi({
      description: 'Timestamp when terms and conditions were accepted'
    }),
  prefersSpanishCommunication: z.boolean().optional().openapi({
    description: 'Whether the user prefers communication in Spanish'
  }),
  birthDate: z
    .string()
    .datetime()
    .optional()
    .nullable()
    .openapi({ description: 'Birth date of the user as ISO-8601 datetime' }),
  recaptchaToken: z
    .string()
    .optional()
    .openapi({ description: 'reCAPTCHA v3 token for bot verification' })
});

export const registerForEventResponseSchema = z.object({
  data: z.object({
    id: z.string().uuid()
  })
});
